import css from "./modalSeparator.module.scss";

const ModalSeparator = () => {
	return <div className={css.separator} />;
};

export default ModalSeparator;
